@if (absences.length > 0) {
  @if (showHeader()) {
    <sidebar-header
      [title]="'Pending absences' | translate"
      [indicator]="isOwnAbsences ? 0 : absences.length"
      class="block border-0 border-b-2 border-solid border-default"
    />
  }
  @for (absence of absences; track absence.id) {
    <div sidebarRequestItem>
      <absence-summary-item
        role="button"
        tabindex="0"
        [appAbsenceRequest]="{ absenceId: absence.id, isOwnAbsence: isOwnAbsences, originator: 'request-sidebar' }"
        [absence]="absence"
        [isOwnAbsence]="isOwnAbsences"
        [showStatus]="isOwnAbsences"
        [inline]="true"
        [compact]="true"
        [rangeClickShouldNavigate]="true"
        [popoverData]="popoverData$[absence.id] | async"
      />
      @if (absence.id ? alsoIn()[absence.id] : undefined; as otherDepartments) {
        <p class="reset-p mt-xs text-sm text-subtle">
          {{ 'Also in [departments]' | translate: { departments: otherDepartments } }}
        </p>
      }
    </div>
  }
}
